import React, { useEffect, useState } from "react";
import { Grid, CircularProgress, Button, Typography } from "@material-ui/core";

import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import ContentEditor from "./ContentEditor";

import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";
import { Card, CardActions, CardContent } from "../../components/Card";
import { Select, TextInput } from "../../components/Form";
import { identity } from "../../components/utils";

const GET_SYSTEMANNOUNCEMENT = gql`
  query systemAnnouncement($id: Int!) {
    systemAnnouncement(id: $id) {
      id
      title
      promulgator {
        id
        fullName
      }
      type
      contents {
        type
        body
      }
    }
  }
`;

const SAVE_SYSTEMANNOUNCEMENT = gql`
  mutation saveSystemAnnouncement(
    $systemAnnouncementInput: SystemAnnouncementInput!
  ) {
    saveSystemAnnouncement(systemAnnouncementInput: $systemAnnouncementInput)
  }
`;
export default function SystemNotificationForm({
  id,
  onChangeSelect = () => {},
}) {
  //const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const Alert = useAlert();
  const [title, setTitle] = useState("");
  const [contents, setContents] = useState({
    contents: [],
  });
  const typeArray = [
    {
      label: "一般",
      value: "GENERAL",
    },
    {
      label: "重要",
      value: "IMPORTANT",
    },
    {
      label: "很重要",
      value: "VARY_IMPORTANT",
    },
  ];
  const [typeObject, setTypeObject] = useState({});
  const [getSystemAnnouncement, { loading }] = useLazyQuery(
    GET_SYSTEMANNOUNCEMENT,
    {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted({ systemAnnouncement }) {
        if (systemAnnouncement) {
          let newSystemAnnouncement = [];
          systemAnnouncement.contents.map(({ __typename, ...item }) => {
            newSystemAnnouncement.push(item);
          });
          setTitle(systemAnnouncement.title);
          setTypeObject(
            typeArray.find((item) => item.value === systemAnnouncement.type)
          );
          setContents({ contents: newSystemAnnouncement });
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );

  useEffect(() => {
    if (Boolean(id)) {
      getSystemAnnouncement({ variables: { id } });
    } else {
      setTitle("");
      setTypeObject({
        label: "一般",
        value: "GENERAL",
      });
      setContents({ contents: [] });
    }
  }, [id]);

  const [saveSystemAnnouncement, { loading: saveSystemAnnouncementLoading }] =
    useMutation(SAVE_SYSTEMANNOUNCEMENT, {
      onCompleted({ saveSystemAnnouncement }) {
        if (saveSystemAnnouncement) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: () => {
                onChangeSelect();
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    });

  function _saveSystemAnnouncement() {
    const detailsNull = contents.contents.find(
      (item) =>
        (item.type === "HEADING" && item.body === "") ||
        (item.type === "PARAGRAPH" && item.body === "") ||
        (item.type === "IMAGE" && item.body === "") ||
        (item.type === "VIDEO" && item.body === "")
    );

    if (!Boolean(title)) {
      return Alert.alert("", "標題未填寫！", [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    }

    if (detailsNull) {
      return Alert.alert("", "系統公告未填寫完！", [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    }

    let systemAnnouncementInput = {
      title,
      promulgatorId: Number(localStorage.getItem("@fullhouseUserId")),
      contents: contents.contents,
      type: typeObject.value,
    };
    if (Boolean(id)) {
      systemAnnouncementInput.id = id;
    }
    saveSystemAnnouncement({
      variables: {
        systemAnnouncementInput,
      },
    });
  }

  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else if (identity) {
    return (
      <Card>
        <LoadingModal loading={saveSystemAnnouncementLoading} />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item sm={6} xs={6}>
              <TextInput
                value={title}
                onChange={(v) => setTitle(v)}
                label="標題"
                fullWidth
              />
            </Grid>
            <Grid item sm={6} xs={6}>
              <Select
                label="類別"
                items={typeArray}
                value={typeObject}
                onChange={(e, v) => {
                  setTypeObject(v);
                }}
              />
            </Grid>
            {"\u2002"}
          </Grid>
        </CardContent>
        <CardContent>
          <ContentEditor
            data={contents}
            onChangeData={(e) => setContents({ contents: e })}
          />
        </CardContent>
        {contents.contents[0] && (
          <CardActions>
            <Grid container item justify="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={() => _saveSystemAnnouncement()}
              >
                儲存
              </Button>
            </Grid>
          </CardActions>
        )}
      </Card>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={saveSystemAnnouncementLoading} />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item sm={6} xs={6}>
              <Typography color="primary">標題</Typography>
              <Typography>{title}</Typography>
            </Grid>
            <Grid item sm={6} xs={6}>
              <Typography color="primary">類別</Typography>
              <Typography>{typeObject.label}</Typography>
            </Grid>
            {"\u2002"}
          </Grid>
        </CardContent>
        <CardContent>
          <ContentEditor
            edit={false}
            data={contents}
            onChangeData={(e) => setContents({ contents: e })}
          />
        </CardContent>
      </Card>
    );
  }
}
